const formatWattage = (wattage) => {
  const numericWattage = Number(wattage);

  return Number.isFinite(numericWattage) ? String(numericWattage) : "";
};

export default formatWattage;
